
// src/web/components/images-view.jsx

import React from 'react'
import ReactDOM from 'react-dom'
import connect from '../../connects/images-view'
import Dialog from 'react-toolbox/lib/dialog'
import {
  Button,
  IconButton,
} from 'react-toolbox/lib/button'
import { translate } from 'react-i18next'
import _ from 'lodash'
import imagesViewTheme from './themes/images-view.css'
import classnames from 'classnames'
import VideoViewer from './video-viewer.jsx'
import videoViewerTheme from './themes/video-viewer.css'
import Avatar from 'react-toolbox/lib/avatar'

class ImagesViewProvider extends React.Component {
  onClick = (ev)=> {
    if (!this.props.ui.isVideo || ev.target == ReactDOM.findDOMNode(this.videoviewer_div)) {
      this.onClose()
    }
    else {
      undefined
    }
  }

  onClose = ()=> this.props.closeImagesView(this.props)

  showPrevImage = ()=> {
    if ( this.props.imagesViewFiles.length - 1 > this.props.ui.index) {
      const index = this.props.ui.index + 1
      this.props.updateUI({ 
        index: index,
        isVideo: !!this.props.imagesViewFiles[index].file.content_type.match(/^video|audio/)
      })
    }
  }
  showNextImage = ()=> {
    if ( this.props.ui.index > 0 ) {
      const index = this.props.ui.index - 1
      this.props.updateUI({
        index: index,
        isVideo: !!this.props.imagesViewFiles[index].file.content_type.match(/^video|audio/)
      })
    }
  }

  render() {
    const {
      t,
      ui,
      updateUI,
      imagesViewFiles,
      onClose,
      children,
    } = this.props

    var file
    if (ui.active && ui.mode == 'OUT_OF_LIST') {
      file = ui.selected_file
    } else if (ui.active && imagesViewFiles) {
      if(imagesViewFiles.length < 1) return null // esc key pressed
      file = imagesViewFiles[ui.index].file
    }

    const left_btn = ui.active ? ui.index == imagesViewFiles.length - 1 || typeof ui.index == 'undefined' : undefined
    const right_btn = ui.active ? ui.index == 0 || typeof ui.index == 'undefined' : undefined

    return (
      <div style={{ display: 'flex' }}>
        {ui.active &&
          <Dialog
            className={imagesViewTheme.dialog}
            active={ui.active}
            onEscKeyDown={this.onClose}
            onOverlayClick={this.onClose}
            type="fullscreen" >
              <IconButton className={imagesViewTheme.close}
                icon='close'
                onClick={this.onClose}
                ref={(c)=> this.iconbutton = c} />
              {file.content_type.match(/^video/) &&
                <a key={file.video_id} style={{right: 0,marginRight: 100,marginTop: -15,position: 'absolute', zIndex: 1}} href={file.file.orig_url}>
                    <Avatar className={videoViewerTheme.avatar}
                      icon='file_download' />
                </a>
              } 
              <nav className={imagesViewTheme.nav}>
                {ui.mode != 'OUT_OF_LIST' &&
                  <div className={classnames(imagesViewTheme.navArea, imagesViewTheme.navPrev)} onClick={this.showPrevImage}>
                    <IconButton icon='keyboard_arrow_left' disabled={left_btn} />
                  </div>
                }
                <div onClick={(ev)=> this.onClick(ev)}
                  className={imagesViewTheme.imageArea}
                  ref={(c)=> this.videoviewer_div = c} >
                  {ui.isVideo &&
                    <VideoViewer key={file.imagesViewFiles_id} video={file} t={t} />
                  }
                  {!ui.isVideo &&
                    <img src={file.file.url} className={imagesViewTheme.image} />
                  }
                </div>
                {ui.mode != 'OUT_OF_LIST' &&
                  <div className={classnames(imagesViewTheme.navArea, imagesViewTheme.navNext)} onClick={this.showNextImage}>
                    <IconButton icon='keyboard_arrow_right' disabled={right_btn} />
                  </div>
                }
              </nav>
          </Dialog>
        }
        {children}
      </div>
    )
  }
}

export default connect(ImagesViewProvider)



// WEBPACK FOOTER //
// ./src/web/components/images-view.jsx